import React from 'react';
import { useTranslate } from '@hooks';
import { AlertPopover, Input } from '@dotone/react-ui-core';

const BlockInvalidOrderSwitch = ({ onToggle, value, ...otherProps }) => {
  const { t } = useTranslate('common');

  return (
    <Input
      type="switch"
      name="blockInvalidOrders"
      checked={value}
      label={
        <>
          {t('blockInvalidOrder')}
          <AlertPopover t={t} tKey={'hints.blockInvalidOrder'} />
        </>
      }
      onChange={onToggle}
      {...otherProps}
    />
  );
};

export default BlockInvalidOrderSwitch;
